// extracted by css-extract-rspack-plugin
export default {"pill":"AW53U","input":"wAbNv","option":"Oy0hn","pillContent":"JkxYo","optionContent":"L1jn2","optionIcon":"_aCkC","optionIconDisabled":"Z5yqg","disabledInfoIcon":"dVsCv"};